var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"big-title",class:{ light: _vm.light, en: _vm.lang=='en' }},[_c('div',{staticClass:"line"}),_c('div',{staticClass:"zh"},[_vm._v(_vm._s(_vm.lang=='zh'?_vm.zh:_vm.en))]),_c('div',{staticClass:"en"},[_vm._v(_vm._s(_vm.en))])])
}
var staticRenderFns = []

export { render, staticRenderFns }